<div class="wrapper" style="overflow-x: hidden">
  <div class="sidebar" data-active-color="danger" data-color="white">
    <sidebar-cmp [routeMenu]="menuSidebar"></sidebar-cmp>
  </div>
  <div class="main-panel">
    <navbar-cmp [routeMenu]="menuSidebar"></navbar-cmp>
    <app-impersonation-banner></app-impersonation-banner>
    <div class="content">
      <ng-container>
        <router-outlet></router-outlet>
      </ng-container>

    </div>
    <footer-cmp></footer-cmp>
  </div>

  <!-- Command palette globale (⌘K / Ctrl+K) -->
  <app-command-palette></app-command-palette>
</div>
